import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { DataService } from './data.service';
import { RequestAppealPage } from 'src/app/modals/request-appeal/request-appeal.page';
import { ViolationInfoPage } from 'src/app/modals/violation-info/violation-info.page';
import {intervalToDuration} from 'date-fns';
import {  Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import {SearchViolationsPage} from 'src/app/modals/search-violations/search-violations.page'
import { LoaderService } from './loader.service';
import { ErrorHandlerService } from './error-handler.service';
import { PlatformService } from '../platform.service';
import { ToastService } from './toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AppealsService {
  private mySubject = new Subject<any>();
  loadTickets
  searchItem
  loaded=false;
  width=window.innerWidth;
  height=window.innerHeight;
  violations = {};
 
  searchText = '';
  searchData = {};
  appealTypes = {
    denied: 1,
    reduced: 2,
    cancelled: 3,
  };
  constructor(
    private toasterSRV:ToastService,
    public platformSRV:PlatformService,
    private errorSRV:ErrorHandlerService,
    private loaderSRV:LoaderService,
    private router: Router,
    public modalController: ModalController,
    private dataService: DataService,
    public translateService: TranslateService,
  ) { }
  reloadHomepage(value:any) {
    this.mySubject.next(value);
  }
  async allViolationspage(){
    const desktopModal = await this.modalController.create({
      component: SearchViolationsPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long'
    });
    const mobileModal = await this.modalController.create({
      component: SearchViolationsPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass:"modal-mobile-normal"
    })
    const tabletModal = await this.modalController.create({
      component: SearchViolationsPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1, 
      cssClass:"modal-tablet-normal"
    })
   
    
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
    modal.present()
    modal.onDidDismiss().then(()=>{
      this.searchData['violations']=[]
      this.searchText=''
    })
  }
  getViolations() {
    this.loaded=false
    var start = new Date()
    this.dataService.getData('violations/appeals')
    .subscribe({
      next:data=>{
        if(data['status']=="success"){
          data['violations'].forEach(element => {
            if(start<new Date(element['Due'])){
              element['timeLeft']= intervalToDuration({
                start: start,
                 end: new Date(element['Due'])
              })
            }

            element['decodedEvidence'] = JSON.parse(element['evidence']);
          });
          
          
          this.loaded=true
          this.violations = data;
        
        }
          else {
            this.errorSRV.displayErrorMessage(data,true)
           
           
            }
          
      },error:err=>{
        this.errorSRV.displayErrorMessage(err,true)
      }
      
    });
  }
  // getUnpaidViolations() {
   
  //   return this.dataService.getData('violations/appeals')
  //   .pipe(
  //     map(data=>{
        

       
  //     }

  //     )
  //   )
  //   // .subscribe((res) => {
  //   //   
      
      
  //   // });
  // }

  showAppealInformationToggle(index) {
    this.violations['violations'][index].open = !this.violations['violations'][
      index
    ].open;
  }
  tipo(ev){
    this.loaded=false;
    setTimeout(() => {
      this.loaded=true
    }, 500);
  }
  onSearch() {
    if( this.searchText.length>0){
      this.searchData['violations']=[]
      this.loadTickets=false
      const url = 'violations/appeals/search';
      const data = {
        ticket_plate: this.searchText,
      };
  
      this.dataService.postData(url, data)
      .pipe(map(data=>{
        
        
        for(var i = 0;i<data['violations'].length;i++){
          if(data['violations'][i]['myViolation']!=='1'){
           
            
           this.searchData['violations'].push(data['violations'][i])
          }
        }
       
        
        this.loadTickets=true
      }))
      .subscribe();
    }
    
  }
  appealDateCheck(violation) {
    const appealDateMilliseconds = (new Date(violation.AppealDate)).getTime();
    
    return appealDateMilliseconds > Date.now();
  }
  onAssociate(VehicleID) {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')

    const url = `vehicles/associate/${VehicleID}`;
    this.dataService.postData(url, {}).subscribe((res) => {
      if(res['status']=='success'){
        this.loaderSRV.dismissLoader()
        this.getViolations();
        this.searchData = {};
        this.toasterSRV.presentToast(res['message'])
      } else {
        this.loaderSRV.dismissLoader()
        this.getViolations();
        this.searchData = {};
      }
     
    });
  }
  isCancelled(type){
    if(type==this.appealTypes.cancelled){
      return 'line-through'
    }
  }
  async openViolationInfoModal(violation) {
    const desktopModal = await this.modalController.create({
      component: ViolationInfoPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        violation,
      }
    });
    const mobileModal = await this.modalController.create({
      component: ViolationInfoPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint:  1,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        violation,
      }
    });
    const tabletModal = await this.modalController.create({
      component: ViolationInfoPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint:  1,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        violation,
      }
    });
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
    modal.present()
    
  
  }

  async openRequestAppealModal(violation) {
    const desktopModal = await this.modalController.create({
      component: RequestAppealPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps: {
        violation,
      }
    });
    const mobileModal = await this.modalController.create({
      component: RequestAppealPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint:  0.85,
      cssClass: 'modal-mobile-normal',
      componentProps: {
        violation,
      }
    });
    const tabletModal = await this.modalController.create({
      component: RequestAppealPage,
      breakpoints: [0.5,  0.85,1],
      initialBreakpoint:  0.85,
      cssClass: 'modal-tablet-normal',
      componentProps: {
        violation,
      }
    });
    var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
    modal.onDidDismiss().then((res) => {
     
      const { data } = res;
      if (data) {
        if (data.reload) {
          this.modalController.dismiss()
          this.getViolations();
          this.reloadHomepage('change')
        }
      }
    });
    modal.present()
    
  }
}
